const BACKEND_URL = "https://pharmecy-backend.onrender.com/";

// const BACKEND_URL = "http://localhost:3000/";

export default BACKEND_URL;